export default __webpack_public_path__ + "static/media/e00egroup_4423.e43b69e2.png";